import { IPasswordRequirements } from '../../../system/passwordRequirements/entities';
import { PostMethod } from '../../serviceHelper';

const getMethods = (service: 'main', controller: 'Password') => ({
	ChangePassword: new PostMethod<any, any>({
		service,
		controller,
		method: 'ChangePassword'
	}),
	SendResetPasswordMail: new PostMethod<any, any>({
		service,
		controller,
		method: 'SendResetPasswordMail'
	}),
	ResetPassword: new PostMethod<any, any>({
		service,
		controller,
		method: 'ResetPassword'
	}),
	GetPasswordRequirements: new PostMethod<IPasswordRequirements, any>({
		service,
		controller,
		method: 'GetPasswordRequirements'
	})
});

export { getMethods };
